import {useContext, useRef, useState, useEffect} from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { toast } from 'react-toastify';

import UserContext from "../../components/UserContext";
import Logo from './logo.png';


import qa_gif from './qa.gif';
import qa_image from './qa.png';

import survey_gif from './survey.gif';
import survey_image from './survey.png';

import flashcards_gif from './flashcards.gif';
import flashcards_image from './flashcards.png';



const GIFS = {
    'QA': qa_gif,
    'SURVEY': survey_gif,
    'FLASHCARDS': flashcards_gif,
}

const IMAGES = {
    'QA': qa_image,
    'SURVEY': survey_image,
    'FLASHCARDS': flashcards_image,
}

const paragraph_styles = 'mt-6 leading-relaxed text-lg';

const FeatureCard = ({title, src, hoverSrc, alt}) => {
    const [isHovering, setIsHovering] = useState(false);
    const [isBig, setIsBig] = useState(false);

    useEffect(() => {
        if (isBig) {
            document.body.style.overflow = 'hidden';
        }
        return ()=> document.body.style.overflow = 'unset';
    }, [isBig]);

    const video  = <img
        src={hoverSrc}
        preload={"auto"}
        alt={"Video for the image"} />;

    return (
        <>
            {
                isBig &&
                <div
                    className={"fixed inset-0 bg-blue-700 bg-opacity-50 z-20 flex items-center justify-center"}
                    onClick={
                        () => setIsBig(p => !p)
                    }
                >
                    <div className={'sm:w-2/3 w-11/12 rounded overflow-clip shadow-sm'}>
                        {
                            video
                        }
                    </div>
                </div>
            }
        <div
            className={'bg-blue-50 rounded-md w-full md:w-1/4 mt-4 overflow-clip relative shadow-sm cursor-pointer ' +
                'hover:shadow-md active:opacity-75 transition-shadow'
            }
            onClick={
                () => setIsBig(p => !p)
            }
            onMouseEnter={
                () => setIsHovering(true)
            }
            onMouseLeave={
                () => setIsHovering(false)
            }
        >

            <div>
                <img src={src} className={'z-0'} preload={"auto"} alt={alt} />
                <div className={`absolute top-0  ${isHovering ? 'z-10' : '-z-10'}`}>
                    {video}
                </div>
            </div>
            <h3 className={'m-4 text-lg font-bold text-blue-950'}>{title}</h3>
        </div>
       </>
    )
}

function Landing() {
    const user = useContext(UserContext);
    const joinRef = useRef();
    const navigate = useNavigate();
    const [email, setEmail] = useState('');

    const handleSubscribe = (email) => {
        const formData = {
            "fields": [{
                "objectTypeId": "0-1",
                "name": "email",
                "value": email
            }],
            "context": {
                "pageUri": "www.paperpilot.app",
                "pageName": "Landing page"
            }
        }

        const portalId = "24158711";
        const formGuid = "3257fb3a-016b-4f40-9dbc-5e749e020757"

        fetch(
            `https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${formGuid}`, {
                method: "POST", // or 'PUT'
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            })
            .then(
                (resp) => {
                    setEmail('');
                    toast("We'll keep you updated ;)", {
                        position: "bottom-center",
                        autoClose: 3000,
                    });
                }
            )
            .catch(
                (err) => console.error('Hubspot join error', err)
        )
    }

    if (user) {
        return <Navigate to={'/manager'} />
    }

    const centered = 'container mx-auto px-8';

    return (
        <div className={'scroll-smooth'}>

            {/*     Hero Section    */}
            <section className={'w-screen mx-auto h-screen flex items-center'}>
                <div className={'w-full border-b absolute top-0 bg-gray-50'}>
                    <nav className={`flex justify-between items-center py-2 ${centered}`}>
                        <div>
                            {/*     Left Side       */}
                            <img src={Logo} className={'w-10'}/>
                        </div>
                        <div>
                            {/*     Right Side      */}
                            <button
                                className={'px-4 py-2 bg-blue-700 text-blue-50 rounded-md hover:underline active:opacity-75'}
                                onClick={
                                    () => navigate('/login')
                                }
                            >
                                Login
                            </button>
                        </div>
                    </nav>
                </div>

                <div className={`${centered}`}>
                    <div className={'w-full sm:max-w-xl'}>
                        <h1 className={'text-2xl font-bold md:text-4xl text-blue-950 drop-shadow-sm'}>
                            Paper Pilot - retain more from your readings
                        </h1>
                        <h2 className={'text-md md:text-lg text-left mt-6 text-blue-950'}>
                            We're developing a system to <span className={'font-bold'}>facilitate
                            reading</span> to get the most out of your readings.
                        </h2>
                        <div className={'flex mt-4'} ref={joinRef}>
                            {/*     Email Collector     */}
                            <input
                                className={'border-r-0 rounded-l-full pl-4 outline-0 text-sm sm:text-base bg-blue-50 py-2 px-4 w-[30ch]'}
                                placeholder={'your email'}
                                autoComplete={'email'}
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                onKeyDown={
                                    (e) =>
                                        e.code === 'Enter' && handleSubscribe(email)
                                }
                            />
                            {/**/}
                            <button
                                className={'bg-blue-700 min-w-fit text-blue-50 px-4 ' +
                                    'rounded-r-full hover:underline active:opacity-80 transition-all '+
                                    'text-sm sm:text-base'
                                }
                                onClick={() => handleSubscribe(email)}
                            >
                                Join Us
                            </button>
                        </div>
                    </div>

                </div>
            </section>

            <section className={`${centered}`}>
                <h2 className={'text-2xl md:text-4xl font-bold text-blue-950 text-left'}>How it works</h2>
                <div className={'flex flex-wrap justify-between'}>
                    <FeatureCard
                        src={IMAGES.SURVEY}
                        hoverSrc={GIFS.SURVEY}
                        title={'Survey your reading material'}
                    />
                    <FeatureCard
                        src={IMAGES.QA}
                        hoverSrc={GIFS.QA}
                        title={'Write some relevant questions and answer them'}
                    />
                    <FeatureCard
                        src={IMAGES.FLASHCARDS}
                        hoverSrc={GIFS.FLASHCARDS}
                        title={'Study the generated flashcards'}
                    />
                </div>
            </section>


            <section className={`${centered} mt-16`}>
                <h2 className={'text-2xl md:text-4xl font-bold text-blue-950 text-left'}>Vision</h2>
                <div className={'max-w-prose mx-auto'}>
                    <p className={paragraph_styles + ' indent-6 '}>
                        Let me share my story with you.
                        It all started when I was taking a social science course,
                        and right before the final exam, I had to study the textbook.
                        Like many students, I turned to the traditional method of creating flashcards.
                        But the process was incredibly time-consuming and inefficient.
                        I found myself reading the textbook, writing down questions and answers in Google Docs,
                        and then transferring them to Quizlet.
                        It was a cumbersome process that left me feeling frustrated.
                    </p>
                    <p className={paragraph_styles}>
                        That experience sparked an idea in me. Why do we still rely on outdated methods to consume text?
                        Why haven't we found a more efficient and engaging way to extract valuable information from our
                        readings? Research shows that we retain very little from the text we read, despite spending a
                        significant amount of time consuming it. This realization fueled my determination to create a
                        tool that would change the way we access and retain information.
                    </p>
                    <p className={paragraph_styles}>
                        With Paper Pilot, my vision is to revolutionize the way we engage with text.
                        Our platform is not limited to research papers; it's a flexible tool that can be applied to any
                        type of content. Whether it's articles, books, or even personal documents, Paper Pilot empowers
                        users to extract the value they seek efficiently.
                    </p>
                    <p className={paragraph_styles}>
                        By offering various types of engagement, such as flashcards and more, we provide a thoughtful
                        and purpose-driven approach to accessing information. Our aim is to enhance the reading
                        experience, allowing users to fully comprehend and retain the essence of what they consume.
                        Through constant expansion and innovation, we will continue to add new content types and
                        exercise formats, ensuring a versatile and personalized learning experience.
                    </p>
                    <p className={paragraph_styles}>
                        At its core, Paper Pilot represents a shift towards a more effective and mindful way of
                        acquiring knowledge. We believe that by harnessing the power of technology and human-centered
                        design, we can unlock the full potential of the content we encounter, helping users achieve
                        their learning goals efficiently and effortlessly.
                    </p>
                    <p className={paragraph_styles}>
                        Join us on this transformative journey as we redefine how we engage with information and
                        empower individuals to extract maximum value from their readings.
                    </p>
                    <p className={paragraph_styles}>
                        Together, let's navigate the vast seas of knowledge with ease and purpose.
                    </p>
                    <p className={paragraph_styles}>
                        Warm regards,
                    </p>
                    <p className={paragraph_styles}>
                        Eren Suner
                    </p>
                </div>
            </section>

            <footer className={'h-80'}/>
        </div>
    );
}

export default Landing;